<template>
  <a-modal
    v-model="visible"
    title="乐橙订单凭证设置"
    ok-text="确认"
    :width="600"
    cancel-text="取消"
    @ok="handleOk">
    <a-form layout="horizontal" :form="form">
      <a-form-item label="乐橙订单凭证：">
        <a-input
          v-decorator="['lcToken', { rules: [{ required: true, message: '请输入乐橙订单凭证' }]}]"
          type="textarea"
          rows="6"
          placeholder="请输入乐橙订单凭证"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { getLcOrderToken, pullLcOrderToken } from '@/api/order/orderList'
export default {
  data () {
    return {
      visible: false,
      form: this.$form.createForm(this, { lcToken: '' })
    }
  },
  methods: {
    init () {
      this.visible = true
      this.handleGetLcToken()
      this.form.resetFields()
    },
    handleGetLcToken () {
      getLcOrderToken().then(res => {
        console.log(res)
        if (res.data && res.data.lcToken) {
          this.form.setFieldsValue({
            lcToken: res.data.lcToken
          })
        }
      })
    },
    handleOk () {
      this.form.validateFields((err, fieldsValue) => {
        if (err) {
          return
        }
        const form = this.form.getFieldsValue()
        console.log(form)
        pullLcOrderToken(form).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.$store.commit('setLcStatus', 1)
            this.visible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.ant-form-item {
  display: flex !important;
}
/deep/.ant-form-item-control-wrapper {
  flex: 1 !important;
  width: 100% !important;
}
</style>
